import { filter, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BcPrivilegesFacade } from '@bayclubs/employee-auth';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CanUseCampsGuard {

    constructor(private privilegesFacade: BcPrivilegesFacade, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
        : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.privilegesFacade.privileges$
            .pipe(
                filter(x => !!x),
                map(privileges => {
                    if (privileges.hasPrivilege('Camps', 'campsCanView', [])) {
                        return true;
                    }
                    this.router.navigate(['/forbidden']);
                }))
    }

}
